'use strict';

function cleanup(element) {
  if (!element)
    return;
  if (element.parent) {
    element.parent.removeChild(element);
  }
  element.destroy();
  element = null;
}

exports.cleanup = cleanup;
//# sourceMappingURL=cleanup.js.map
